import React from 'react';
import './css/hojadeestilos.css';

function AppLayout(props){
	return(
		<div>
			{props.children}
		</div>
	)
}

export default AppLayout;